(function () {
  const stickyBar = document.getElementById('sticky-atc-bar');
  if (!stickyBar) return;

  // Watch the buy-buttons block inside the product details column specifically,
  // so product-recommendation buy-buttons on the same page don't trigger it
  const sentinel = document.querySelector('.product-details .buy-buttons-block');
  if (!sentinel) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const show = !entry.isIntersecting;
      stickyBar.classList.toggle('sticky-atc-bar--visible', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
    },
    { threshold: 0 }
  );
  observer.observe(sentinel);

  // Update price inside button and disabled state when variant changes
  const section = stickyBar.closest('.shopify-section');
  const button = stickyBar.querySelector('.sticky-atc-bar__button');
  const buttonPriceEl = stickyBar.querySelector('.sticky-atc-bar__button-price');

  if (section && buttonPriceEl) {
    section.addEventListener('variant:update', (event) => {
      const newPriceEl = event.detail.data.html.querySelector('[ref="priceContainer"] .price');
      if (newPriceEl) {
        buttonPriceEl.textContent = ' — ' + newPriceEl.textContent.trim();
      }
      if (button && event.detail.resource) {
        button.disabled = !event.detail.resource.available;
      }
    });
  }
})();
